module.exports = __webpack_public_path__ + "static/media/1533d8e8-8099-400b-b73b-86c439051d1a.bec44b06.JPG";